// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_Home__pFU3G {
  overflow: hidden;
}
.Home_Home__pFU3G ::-webkit-scrollbar {
  width: 0;
  background: transparent;
}
.Home_Home__pFU3G .Home_contentContainer__FqHST {
  height: 100vh;
  box-sizing: border-box;
  max-height: 80vh;
  overflow: auto;
}
.Home_Home__pFU3G .Home_darkTheme__IHmeK {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #212121;
  color: #fafafa;
}
.Home_Home__pFU3G .Home_darkTheme__IHmeK a {
  color: white;
}
.Home_Home__pFU3G .Home_lightTheme__9SEyo {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #fafafa;
  color: #212121;
}
.Home_Home__pFU3G .Home_lightTheme__9SEyo a {
  color: #212121;
}
.Home_Home__pFU3G .Home_colorfulTheme__zM3Fa {
  font-family: "Courier New", monospace;
  font-size: 1.2rem;
  background-color: #91f88b;
  color: #212121;
}
.Home_Home__pFU3G .Home_colorfulTheme__zM3Fa a {
  color: #212121;
}`, "",{"version":3,"sources":["webpack://./src/views/Home/Home.module.scss","webpack://./src/assets/_globalStyleElements.module.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,QAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAFJ;AAKE;ECUA,qCA3BiB;EA4BjB,iBA3Be;EA4Bf,yBAvBgB;EAwBhB,cAvBiB;ADWnB;ACaE;EACE,YAAA;ADXJ;AADE;ECiBA,qCArCiB;EAsCjB,iBArCe;EAsCf,yBAhCiB;EAiCjB,cAlCgB;ADqBlB;ACcE;EACE,cApCc;ADwBlB;AAPE;ECwBA,qCA/CiB;EAgDjB,iBA/Ce;EAgDf,yBAAA;EACA,cA5CgB;AD8BlB;ACeE;EACE,cA9Cc;ADiClB","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.Home {\n  overflow: hidden;\n\n  ::-webkit-scrollbar {\n    width: 0;\n    background: transparent;\n  }\n\n  .contentContainer {\n    height: 100vh;\n    box-sizing: border-box;\n    max-height: 80vh;\n    overflow: auto;\n  }\n\n  .darkTheme {\n    @include darkTheme;\n  }\n  .lightTheme {\n    @include lightTheme;\n  }\n  .colorfulTheme {\n    @include colorfulTheme;\n  }\n}\n","$globalFontFamily: 'Courier New', monospace;\n$globalFontSize: 1.2rem;\n\n$globalBorderRadius: 1rem;\n$globalHomeContentContainerPadding: 2.5rem;\n\n$globalDarkColor: #212121;\n$globalLightColor: #fafafa;\n$globalUnderlayRGBAColorDark: rgba(255, 255, 255, 0.05);\n$globalUnderlayRGBAColorLight: rgba(208, 209, 255, 0.5);\n\n$globalHighlightColor: #f6a3a0;\n$globalHighlightColorDark: #fafafa;\n$globalHighlightColorLight: #454555;\n\n\n$colorsReact: #61dafb;\n$colorsKotlin: #7f52ff;\n$colorsReactRgba: rgba(97, 218, 251, 0.2);\n\n$gradientColor1: #845ec2;\n$gradientColor1: #d65db1;\n$gradientColor1: #ff9671;\n$gradientColor1: #ffc75f;\n$gradientColor1: #f9f871;\n\n@mixin darkTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalDarkColor;\n  color: $globalLightColor;\n  a {\n    color: white;\n  }\n}\n\n@mixin lightTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: $globalLightColor;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin colorfulTheme {\n  font-family: $globalFontFamily;\n  font-size: $globalFontSize;\n  background-color: #91f88b;\n  color: $globalDarkColor;\n  a {\n    color: $globalDarkColor;\n  }\n}\n\n@mixin darkThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorDark;\n}\n\n@mixin lightThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n\n@mixin colorfulThemeContent {\n  padding: inherit;\n  border-radius: inherit;\n  background-color: $globalUnderlayRGBAColorLight;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Home": `Home_Home__pFU3G`,
	"contentContainer": `Home_contentContainer__FqHST`,
	"darkTheme": `Home_darkTheme__IHmeK`,
	"lightTheme": `Home_lightTheme__9SEyo`,
	"colorfulTheme": `Home_colorfulTheme__zM3Fa`
};
export default ___CSS_LOADER_EXPORT___;
